import { CARD, LAYOUT_LIST, TEXT } from '../items';
import { Translator } from '../Translator';
import { translate } from './translate';
import {
  optionalFieldsInEditor,
  optionalFieldValues
} from '../utils/optionalFields';

const markdownToHtml = (markdown: string): string => {
  if (!markdown) return '';

  return markdown.replace(/==(.+?)==/g, '<mark>$1</mark>');
};

export const Statement3: Translator = sequence => {
  return translate(sequence, item => {
    switch (item.__typename) {
      case 'Card':
        return {
          id: item.id,
          type: LAYOUT_LIST,
          values: {
            align: 'center'
          },
          items: [
            {
              type: CARD,
              id: '1',
              values: {
                clearStyles: 'lg',
                height: 'auto',
                width: '80vw',
                align: 'center'
              },
              items: [
                {
                  id: `${item.id}_title`,
                  type: TEXT,
                  values: {
                    ...optionalFieldValues(
                      optionalFieldsInEditor(['title']),
                      'title',
                      'Add statement'
                    ),
                    value: markdownToHtml(item.title || ''),
                    variant: 'heading1_bolder',
                    align: 'center',
                    canUseMarkTag: true
                  },
                  items: []
                }
              ]
            }
          ]
        };
      default:
        return null;
    }
  });
};
